import {memo} from 'react';

import styled from 'styled-components';

import {bodyBold} from '~/shared/theme/typography';
import ImageWithAlt from '~/shared/components/ImageWithAlt';
import {Link} from '~/shared/router';
import {getLocalizationService} from '~/shared/services/localisationService';

import instagramIcon from '../../assets/instagramIcon.svg';
import facebookIcon from '../../assets/facebookIcon.svg';

const socialNetworks = [
  {
    iconName: 'facebook-footer',
    icon: facebookIcon,
    alt: 'facebook',
    href: 'https://www.facebook.com/10bis/',
  },
  {
    iconName: 'instagram-footer',
    icon: instagramIcon,
    alt: 'instagram',
    href: 'https://www.instagram.com/10bis/',
  },
];

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: ${({theme}) => theme.colors.surface};
`;

const Title = styled.span`
  display: block;
  ${bodyBold}
`;

const StyledIcon = styled(ImageWithAlt)`
  width: 35px;
  height: 35px;
`;

const SocialsContainer = styled.div`
  display: flex;
  gap: 24px;
  height: 40px;
  align-items: center;
`;

const StyledLink = styled(Link)`
  display: block;
  width: 35px;
  height: 35px;
`;

const SocialNetworks = () => {
  const {t} = getLocalizationService();
  return (
    <Root>
      <Title>{t('follow_us')}</Title>
      <SocialsContainer>
        {socialNetworks.map(socialNetwork => (
          <StyledLink key={socialNetwork.iconName} href={socialNetwork.href} target="_blank">
            <StyledIcon src={socialNetwork.icon} alt={socialNetwork.alt} />
          </StyledLink>
        ))}
      </SocialsContainer>
    </Root>
  );
};

export default memo(SocialNetworks);
